import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionService } from '../services/session.service';
import { Roles } from './role';

@Injectable({ providedIn: 'root' })
export class AlreadyLoggedInGuard implements CanActivate {
  constructor(private router: Router, private sessionService: SessionService) {}

  canActivate(): boolean {
    const isLoggedIn = this.sessionService.isLoggedIn();
    
    if (isLoggedIn) {
        const role = this.sessionService.getUserRole();    
        if (role === Roles.USER) {
          this.router.navigate(['/user/dashboard']);
        } else if (role === Roles.SYSTEM_ADMIN) {
          this.router.navigate(['/system-admin/dashboard']);
        } else {
          this.router.navigate(['/auth/sign-in']);
        }
        return false;
    }
    
    return true;
  }
}